import type { NewsListAjaxUpdateConfig } from './news-list-ajax-update';

function hasActiveActivityFilters(root: ParentNode): boolean {
  const activityFormat = root.querySelector<HTMLSelectElement>('#activity_format')?.value ?? '';
  const activityType = root.querySelector<HTMLSelectElement>('#activity_type')?.value ?? '';

  return Boolean(activityFormat || activityType);
}

export function updateActivityFiltersEmptySummary(
  root: ParentNode,
  config: Pick<NewsListAjaxUpdateConfig, 'gridSelector' | 'cardSelector'>,
): void {
  const summary = root.querySelector<HTMLElement>('[data-activity-filters-summary]');
  
  if (!summary) return;

  if (!hasActiveActivityFilters(root)) {
    summary.hidden = true;

    return;
  }

  const grid = root.querySelector(config.gridSelector);
  const count = grid?.querySelectorAll(config.cardSelector).length ?? 0;

  summary.hidden = count > 0;
}
